import React from 'react';
import { Link } from 'react-router-dom';
import ArrowIcon from './ArrowIcon';

const SOCIAL_ICONS = {
  LinkedIn: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433a2.062 2.062 0 01-2.063-2.065 2.064 2.064 0 112.063 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
    </svg>
  ),
  X: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
      <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-4.714-6.231-5.401 6.231H2.742l7.736-8.849L1.254 2.25H8.08l4.253 5.622zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
    </svg>
  ),
  GitHub: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0112 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" />
    </svg>
  ),
  Instagram: (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
      <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z" />
    </svg>
  ),
};

const SERVICES_ITEMS = [
  { label: 'IoT Product Development',  to: '/iot-product-design-services' },
  { label: 'Embedded Hardware Design', to: '/embedded-hardware-design' },
  { label: 'Embedded Firmware Dev',    to: '/embedded-firmware-development' },
  { label: 'IoT Dashboards & Apps',    to: '/iot-dashboards-web-mobile' },
  { label: 'IoT Cloud Integration',    to: '/iot-cloud-integration' },
  { label: 'Research & R&D',           to: '/research-innovation-rnd' },
];

const FOOTER_LINKS = [
  {
    h: 'Sectors',
    items: [
      { label: 'Healthcare',         to: '/industries/healthcare' },
      { label: 'Utilities & Energy', to: '/industries/utilities-energy' },
      { label: 'Industrial IoT',     to: '/industries/industrial-iot' },
      { label: 'Education',          to: '/industries/education' },
    ],
  },
  {
    h: 'Company',
    items: [
      { label: 'About',    to: '/about' },
      { label: 'Projects', to: '/projects' },
      { label: 'Contact',  to: '/contact' },
      { label: 'Blog',     to: '/blog' },
      { label: 'Careers', href: '#' },
    ],
  },
];

export default function Footer({ hideCTA = false }) {
  return (
    <footer
      id="contact"
      style={{
        position: 'relative',
        background: 'rgba(255,255,255,0.82)',
        padding: '80px 0 32px',
        overflow: 'hidden',
      }}
    >
      <div
        aria-hidden
        style={{
          position: 'absolute',
          inset: 0,
          opacity: 0.5,
          background:
            'radial-gradient(ellipse at 80% 20%, rgba(255,26,26,0.10), transparent 50%), radial-gradient(ellipse at 20% 80%, rgba(24,24,232,0.10), transparent 50%)',
        }}
      />

      <div style={{ position: 'relative', maxWidth: 1320, margin: '0 auto', padding: '0 32px' }}>
        {/* CTA */}
        {!hideCTA && <div style={{ textAlign: 'center', marginBottom: 72 }}>
          <p
            style={{
              fontFamily: "'Anton', sans-serif",
              fontSize: 'clamp(36px, 6vw, 72px)',
              fontWeight: 400,
              lineHeight: 1.1,
              color: 'var(--ink)',
            }}
          >
            Let's build the <span style={{ color: 'var(--red)' }}>next thing</span> together.
          </p>
          <Link
            to="/contact"
            className="hoverable"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 14,
              marginTop: 32,
              padding: '20px 36px',
              background: 'linear-gradient(135deg, var(--red), #cc0003)',
              color: 'white',
              borderRadius: 999,
              fontSize: 15,
              fontWeight: 700,

              boxShadow: '0 18px 40px rgba(255,0,4,0.35)',
              transition: 'transform 220ms ease, box-shadow 220ms ease',
            }}
            onMouseEnter={e => {
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 24px 52px rgba(255,0,4,0.48)';
            }}
            onMouseLeave={e => {
              e.currentTarget.style.transform = 'translateY(0)';
              e.currentTarget.style.boxShadow = '0 18px 40px rgba(255,0,4,0.35)';
            }}
          >
            Get In Touch
            <ArrowIcon size={16} />
          </Link>
        </div>}

        {/* Footer link grid */}
        <div
          className="footer-links-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'minmax(0, 1.5fr) repeat(3, minmax(0, 1fr))',
            gap: 40,
            paddingTop: 48,
            borderTop: '1px solid var(--line)',
          }}
        >
          {/* Brand col */}
          <div className="footer-brand-col">
            <Link to="/" style={{ display: 'inline-flex', alignItems: 'center' }}>
              <img src="/zonexlogo.png" alt="Zone-X" style={{ height: 40, width: 'auto', display: 'block' }} />
            </Link>
            <p style={{ marginTop: 14, fontSize: 14, color: 'var(--ink-soft)', maxWidth: 320, lineHeight: 1.6 }}>
              Engineering-first studio building reliable products at the intersection of hardware, software, and
              ambition.
            </p>
            <div style={{ marginTop: 20, display: 'flex', gap: 10 }}>
              {[
                { label: 'LinkedIn' },
                { label: 'X' },
                { label: 'GitHub' },
                { label: 'Instagram' },
              ].map(s => (
                <a
                  key={s.label}
                  href="#"
                  className="hoverable"
                  aria-label={s.label}
                  style={{
                    width: 38, height: 38, borderRadius: 10,
                    border: '1px solid var(--line)',
                    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                    background: 'rgba(255,255,255,0.6)',
                    transition: 'all 200ms ease',
                    color: 'var(--ink)',
                  }}
                  onMouseEnter={e => { e.currentTarget.style.background = 'var(--ink)'; e.currentTarget.style.color = 'white'; e.currentTarget.style.borderColor = 'var(--ink)'; }}
                  onMouseLeave={e => { e.currentTarget.style.background = 'rgba(255,255,255,0.6)'; e.currentTarget.style.color = 'var(--ink)'; e.currentTarget.style.borderColor = 'var(--line)'; }}
                >
                  {SOCIAL_ICONS[s.label]}
                </a>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: 'var(--red)', marginBottom: 18 }}>
              Services
            </div>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 10 }}>
              {SERVICES_ITEMS.map(item => (
                <li key={item.label}>
                  <Link
                    to={item.to}
                    className="hoverable"
                    style={{ fontSize: 14, color: 'var(--ink)', transition: 'color 200ms ease' }}
                    onMouseEnter={e => (e.currentTarget.style.color = 'var(--red)')}
                    onMouseLeave={e => (e.currentTarget.style.color = 'var(--ink)')}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Sectors + Company */}
          {FOOTER_LINKS.map(col => (
            <div key={col.h}>
              <div style={{ fontSize: 12, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', color: 'var(--red)', marginBottom: 18 }}>
                {col.h}
              </div>
              <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 10 }}>
                {col.items.map(item => (
                  <li key={item.label}>
                    {item.to ? (
                      <Link
                        to={item.to}
                        className="hoverable"
                        style={{ fontSize: 14, color: 'var(--ink)', transition: 'color 200ms ease' }}
                        onMouseEnter={e => (e.currentTarget.style.color = 'var(--red)')}
                        onMouseLeave={e => (e.currentTarget.style.color = 'var(--ink)')}
                      >
                        {item.label}
                      </Link>
                    ) : (
                      <a
                        href={item.href}
                        className="hoverable"
                        style={{ fontSize: 14, color: 'var(--ink)', transition: 'color 200ms ease' }}
                        onMouseEnter={e => (e.currentTarget.style.color = 'var(--red)')}
                        onMouseLeave={e => (e.currentTarget.style.color = 'var(--ink)')}
                      >
                        {item.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom bar */}
        <div
          style={{
            marginTop: 48, paddingTop: 24, borderTop: '1px solid var(--line)',
            display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap',
            gap: 12, fontSize: 12, color: 'var(--ink-soft)',
          }}
        >
          <span>© 2026 Zone-X Laboratories. All rights reserved.</span>
          <span>BENGALURU, KARNATAKA · INDIA</span>
        </div>
      </div>
    </footer>
  );
}
